/**
 * Used for transferring the bare minumum data on a player.
 */
const version = 1;
const supportedVersions = [1];

const getCurrentVersion = () => version;
const getSupportedVersions = () => [...supportedVersions];
const DEFAULT_CARD_VALUES = {
  NAME: 'Valued Citizen',
  SPECIES: 'Unknown',
  HOMEWORLD: 'Unknown',
  TIER: 'Unknown',
  EMAIL: 'unknown@welcometo.network'
}

const getBaseCardData = (v = version) => {
  const map = {
    1: {
      name: DEFAULT_CARD_VALUES.NAME,
      species: DEFAULT_CARD_VALUES.SPECIES,
      homeworld: DEFAULT_CARD_VALUES.HOMEWORLD,
      tier: DEFAULT_CARD_VALUES.TIER,
      email: DEFAULT_CARD_VALUES.EMAIL
    }
  };

  if (!map[v]) {
    throw new Error('Unsupported version', v);
  }

  return map[v];
};

const createCard = (overrides = {}, v = version) => ({
  v,
  d: {
    ...getBaseCardData(v),
    ...overrides
  }
});

const createCardFromData = ({ species, leader, player, homeworld }) => {
  return createCard({
    name: leader.displayName,
    species: species.displayName,
    homeworld: homeworld.displayName,
    tier: species.tier,
    email: player.email
  });
}

const serializeCard = (card) => {
  return JSON.stringify(card);
};

const deserializeCard = accountString => {
  if (!canDeserializeCard(accountString)) {
    console.warn('Unsupported account version', version);
    return createCard();
  }
}

const canDeserializeCard = accountString => {
  try {
    const deserializedCard = JSON.parse(accountString);
    const { v: version, d: data } = deserializedCard;
    if (version && supportedVersions.includes(version)) {
      return [true, deserializedCard];
    }
  } catch (error) {
    console.warn('canDeserializeCard:', error.message);
  }

  return [false, null];
}

module.exports = {
  getCurrentVersion, getSupportedVersions, getBaseCardData, createCard, createCardFromData,
  serializeCard, deserializeCard, canDeserializeCard, DEFAULT_CARD_VALUES
};
